import { isBoolean } from 'lodash';
import { CoreOptions } from '../interfaces/core-options.interface';
import { CacheCore } from './server';

/**
 * Cache Pure Function
 *
 * @export
 * @param {string} name
 * @param {Options} options
 * @returns Records
 */
export function stored(name: string, options: CoreOptions = {}) /*: Records*/ {
    options.name = name;
    const params = init(options);
    return new CacheCore(params);
}

/**
 * Options Initializer
 *
 * @param {Options} options
 * @returns {Options}
 */
function init(options: CoreOptions): CoreOptions {
    //
    // Set ooptions
    const useMemo = isBoolean(options.useMemo) ? options.useMemo : true;
    const useCache = isBoolean(options.useCache) ? options.useCache : true;

    options.useCache = useCache;
    options.useMemo = useMemo;

    return options;
}
